import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { transactionsTabsOptions } from 'constants/members';
import { fetchMemberTransactions } from 'modules/members/actions';
import MemberProfileComponent from 'modules/members/components/MemberProfileComponent';
import SnackBar from 'modules/common/components/SnackBar';
import { status } from 'constants/general';

import { Wrapper } from './MemberProfileContainer.style';

const MemberProfileContainer = () => {
  const dispatch = useDispatch();

  const ref = useRef(null);

  const { memberTransactionsList, member } = useSelector(state => state.members);
  const { updatingPointsStatus, blockingStatus, snackBarMessage } = member;

  const [queryObject, setQueryObject] = useState({
    startIndex: 0,
    transactionType: transactionsTabsOptions[0].value,
  });
  const [isSnackBarOpen, setIsSnackBarOpen] = useState(false);
  const [snackBarMessageType, setSnackBarMessageType] = useState(status.SUCCESS);

  const params = useParams();
  const { userEmail } = params;

  useEffect(() => {
    const data = {
      email: userEmail,
      transactionType: queryObject.transactionType,
      startIndex: queryObject.startIndex,
    };
    const transactionTabOption = transactionsTabsOptions.find(
      item => item.value === queryObject.transactionType,
    );
    if (
      memberTransactionsList[transactionTabOption.key]?.details?.startIndex ===
        queryObject.startIndex ||
      (queryObject.startIndex === 0 &&
        !memberTransactionsList[transactionTabOption.key]?.details?.data)
    )
      dispatch(fetchMemberTransactions(data));
    else {
      const { scrollHeight, clientHeight } = ref.current;
      const scrollToPosition = scrollHeight - clientHeight - 100;
      ref.current.scrollTo({ top: scrollToPosition, behavior: 'smooth' });
    }
  }, [dispatch, userEmail, queryObject]);

  // Show confirmation message after award/deduct and blocking
  useEffect(() => {
    if (updatingPointsStatus === status.SUCCESS || blockingStatus === status.SUCCESS) {
      setIsSnackBarOpen(true);
      setSnackBarMessageType(status.SUCCESS);
    } else if (updatingPointsStatus === status.FAIL || blockingStatus === status.FAIL) {
      setIsSnackBarOpen(true);
      setSnackBarMessageType(status.FAIL);
    }
  }, [blockingStatus, updatingPointsStatus]);

  const handleTabSelect = value => {
    const transactionTabOption = transactionsTabsOptions.find(item => item.value === value);
    const startIndex = memberTransactionsList[transactionTabOption.key]?.details?.startIndex;
    const pageSize = memberTransactionsList[transactionTabOption.key]?.details?.pageSize;
    const updatedStartIndex = (startIndex && pageSize && startIndex - pageSize) || 0;

    setQueryObject({
      transactionType: value,
      updatedStartIndex,
    });
  };

  const onScroll = () => {
    const transactionTabOption = transactionsTabsOptions.find(
      item => item.value === queryObject.transactionType,
    );
    if (
      memberTransactionsList[transactionTabOption.key]?.details?.startIndex >=
      memberTransactionsList[transactionTabOption.key]?.details?.total
    )
      return;
    if (ref.current) {
      const { scrollTop, scrollHeight, clientHeight } = ref.current;
      if (Math.round(scrollTop + clientHeight) >= scrollHeight) {
        setQueryObject(prevState => ({
          ...prevState,
          startIndex: memberTransactionsList[transactionTabOption.key]?.details?.startIndex,
        }));
      }
    }
  };

  return (
    <Wrapper ref={ref} onScroll={onScroll}>
      <SnackBar
        show={isSnackBarOpen}
        onHide={() => {
          setIsSnackBarOpen(false);
        }}
        messageType={snackBarMessageType}
        message={snackBarMessage}
      />
      <MemberProfileComponent
        queryObject={queryObject}
        setQueryObject={setQueryObject}
        handleTabSelect={handleTabSelect}
      />
    </Wrapper>
  );
};

export default MemberProfileContainer;
